export default __webpack_public_path__ + "static/media/Witchbone Necklace.36557445.jpg";